import { createSlice } from '@reduxjs/toolkit'
import { useCookies } from 'react-cookie'


export const sendMailSuccessSlice = createSlice({
  name: 'sendSuccessMail',
  initialState: {
    email: '',
    comfirmMailFeedback:'',
    resendLoading: false,
    recheckLoading:false
 
  },
  reducers: {
    setEmailRedux: (state, action) => {
      const { email } = action.payload
      state.email = email
    },
    setConfirmMailFeedbackRedux: (state, action) => {
        const { comfirmMailFeedback } = action.payload
        state.comfirmMailFeedback = comfirmMailFeedback
      },
      setResendLoadingRedux: (state, action) => {
        const { resendLoading } = action.payload
        state.resendLoading = resendLoading
      },
      setRecheckLoadingRedux: (state, action) => {
        const { recheckLoading } = action.payload
        state.recheckLoading = recheckLoading
      },
  },
})

export default sendMailSuccessSlice.reducer;

export const {
    setEmailRedux,
    setConfirmMailFeedbackRedux,
    setResendLoadingRedux,
    setRecheckLoadingRedux
  
} = sendMailSuccessSlice.actions

export const getEmailRedux = (state) => state.sendSuccessMail.email
export const getConfirmMailFeedbackRedux = (state) => state.sendSuccessMail.comfirmMailFeedback
export const getResendLoadingRedux = (state) => state.sendSuccessMail.resendLoading
export const getRecheckLoadingRedux = (state) => state.sendSuccessMail.recheckLoading

